import { useMemo } from 'react';
import { ChartDrawingInfoDto, ChartType } from 'types/CodegenReportTypes';
import { useTelemetry } from 'hooks/useTelemetry';

type ChartConfig = {
  chartId: ChartType;
  chartDrawingInfo: ChartDrawingInfoDto;
  isHidden: boolean;
};

type ReportConfig = {
  [key: string]: ChartConfig;
};

export const useChartVisibility = (tempLayout: ReportConfig | undefined, setTempLayout: (layout: any) => void) => {
  const { trackEvent, events } = useTelemetry();

  const visibleCharts = useMemo(() => {
    if (!tempLayout) {
      return [];
    }
    return Object.values(tempLayout).filter((config) => !config.isHidden);
  }, [tempLayout]);

  const hiddenCharts = useMemo(() => {
    if (!tempLayout) {
      return [];
    }
    return Object.values(tempLayout).filter((config) => config.isHidden);
  }, [tempLayout]);

  const toggleChartVisibility = (chartId) => {
    const newLayout = Object.fromEntries(
      Object.entries(tempLayout ?? {}).map(([key, config]) => {
        if (config.chartId === chartId) {
          const isHidden = !config.isHidden;
          trackEvent(isHidden ? events.RemovedChart : events.AddedChart, { chartId });

          return [
            key,
            {
              ...config,
              isHidden,
              chartDrawingInfo: {
                ...config.chartDrawingInfo,
                position: {
                  x: 0,
                  y: -1,
                },
              },
            },
          ];
        }
        return [key, config];
      })
    );
    setTempLayout(newLayout);
  };

  return { visibleCharts, hiddenCharts, toggleChartVisibility };
};
